import PropTypes from 'prop-types';
import {createUseStyles} from 'react-jss';
import Translation from '../../v2/lang/Translation';
import Spacing from '../../v2/style-helper/Spacing';

const useStyles = createUseStyles({
  iconLine: {
    display: 'flex',
    padding: [Spacing.single, Spacing.double],
    backgroundColor: props => props.active && '#f2f2f2',
    
    '&:focus, &:hover': {
      backgroundColor: '#f2f2f2',
    },
  },
  iconText: {
    marginLeft: Spacing.double,
  },
});

export function MenuItem(props) {
  const classes = useStyles({...props});
  
  return (
    <li
      id={`MenuItem--${props.item.name}`}
      role="menuitem"
      onClick={props.onClick}
      aria-selected={props.active}
    >
      <span className={classes.iconLine}>
        <img src={props.item.icon} alt="" />
        <p className={classes.iconText}>{Translation.getText(props.item.translationKey)}</p>
      </span>
    </li>
  );
}

const ItemPropType = {
  icon: PropTypes.string,
  name: PropTypes.string,
  translationKey: PropTypes.string,
};

MenuItem.propTypes = {
  index: PropTypes.number,
  onClick: PropTypes.func,
  active: PropTypes.bool,
  item: PropTypes.shape(ItemPropType),
};

export default MenuItem;
